import React, { createContext, useState, useEffect } from 'react';
import Web3 from 'web3';
import { startAccountSync } from './mainpage/account_sync/account_sync';
import { startEventsSync } from './mainpage/account_sync/events_sync'; 

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState(() => {
        const saved = sessionStorage.getItem('userInfo');
        return saved ? JSON.parse(saved) : {};
    });

    useEffect(() => {
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    }, [userInfo]);

    const updateUser = (info = {}) => {
        setUserInfo(prev => ({
            ...prev,
            ...info,
            ...(info.account && { wallet_address: info.account }),
        }));
    };

    const clearUser = () => setUserInfo({});

    const [web3, setWeb3] = useState(null);
    useEffect(() => {
        if (window.ethereum) setWeb3(new Web3(window.ethereum));
    }, []);



    return (
        <UserContext.Provider value={{ userInfo, updateUser, clearUser, web3 }}>
            {children}
        </UserContext.Provider>
    );
};

export default UserContext;